import type { InteractionModeRequested } from './interaction-mode';

type RequestedModeParams = {
	deepResearchEnabled?: boolean;
	thinkDeeperEnabled?: boolean;
	alphaExtendedThinkingMode?: unknown;
	taskModeEnabled?: boolean;
	fastModeEnabled?: boolean;
};

export const getInteractionModeRequested = ({
	deepResearchEnabled,
	thinkDeeperEnabled,
	alphaExtendedThinkingMode,
	taskModeEnabled,
	fastModeEnabled,
}: RequestedModeParams): InteractionModeRequested => {
	if (deepResearchEnabled) {
		return 'deep_research';
	}

	if (thinkDeeperEnabled || alphaExtendedThinkingMode) {
		return 'think_deeper';
	}

	if (taskModeEnabled) {
		return 'max';
	}

	if (fastModeEnabled) {
		return 'fast';
	}

	return 'auto';
};
